export default __webpack_public_path__ + "static/media/livetv-small.715f76e5.jpg";